/* eslint-disable */

export default {
  init() {
    // JavaScript to be fired on the Woocommerce Order Received page
    $('.header__mobile-menu__list-item.shopping-cart-button > a').text(0);
    $('.main-nav-shopping-cart-button > a').text(0);
  },
  finalize() {
    // JavaScript to be fired on the Woocommerce Order Received page, after the init JS
    function facebookScriptSearch() {
      let intervalID = 0;

      const wait = function wait(ms) {
          return new Promise(r => setTimeout(r, ms));
      };

      const repeat = function repeat(ms, func) {
          return new Promise(r => (intervalID = setInterval(func, ms), wait(ms).then(r)));
      };

      const validateScript = function validateScript() {
          return new Promise(r => {
            if (typeof fbq === 'undefined') {
              return r(console.log('searching for Facebook scripts...'));
            } else {
              clearInterval(intervalID);
              // TODO: Need to add ajax request to get order total

              function getOrderData(url, security, action) {

                $promise = $.ajax({
                  url: woocommerce_order_received.ajaxUrl,
                  method: 'post',
                  dataType: 'json',
                  data: {'security': security, 'action': action }
                });

                $promise.done((response, textStatus, jqXhr) => {
                  console.log('AJAX RESPONSE: ', response.data);
                  fbq('track', 'Purchase', {value: response.data.orderSubtotal, currency: 'USD'});
                  console.log('fbq() make purchase event triggered...')
                });

                $promise.fail((jqXhr, textStatus, errorThrown) => {
                  console.log(jqXhr);
                  console.log(textStatus);
                  console.log(errorThrown);
                });
              };

              getOrderData( woocommerce_order_received.ajaxUrl, woocommerce_order_received.nonce, 'getThankYouOrderData' );

              return r(console.log('validateScript finished...'));
            }
          });
      };

      repeat(500, () => Promise.all([validateScript()])) // 1000 miliseconds = 1 second
      .then(console.log('facebookScriptSearch() all actions started.')); // informs that all actions were started correctly and we are waiting for them to finish
    }

    // facebookScriptSearch();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/woocommerceOrderReceived.js